export const MOBILE_BREAKPOINT = 'xs';